import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa6';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">Aeti Cleaning Services</Link>
          <p>Professional carpet, rug, upholstery, couch, mattress, curtain, blinds, and windows cleaning for homes and businesses across Perth and surrounding suburbs.</p>
          <div className="social-links">
            <a href="https://www.facebook.com/AetiCS" target="_blank" rel="noopener noreferrer" aria-label="Aeti Cleaning Services on Facebook">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/aeticleaningservices" target="_blank" rel="noopener noreferrer" aria-label="Aeti Cleaning Services on Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@aeticleaning" target="_blank" rel="noopener noreferrer" aria-label="Aeti Cleaning Services on TikTok">
              <FaTiktok />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h4>Explore</h4>
          <Link to="/services">Our Services</Link>
          <Link to="/cleaning-process">Aeti Process</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>
        </div>

        <div className="footer-links">
          <h4>Contact</h4>
          <p><strong>Address:</strong> Lowth Road, Beckenham, WA 6107</p>
          <p><strong>Email:</strong> aeticleaningservices@gmail.com</p>
          <p><strong>Phone:</strong> <a href="tel:+61422519996">+61 422 519 996</a></p>
        </div>
      </div>

      <div className="copyright">
        <p>© 2026 Aeti Cleaning Services. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
